import { plainToInstanceWithLVS } from '@goparrot/common';
import { StoreItemsExposeGroup, StoreItemTypeEnum } from '../enum';
import { ReadCategoryDto, ReadItemBaseDto, ReadItemOptionsDto, ReadStoreItemBundleDto, ReadStoreItemDto, ReadStoreItemGroupDto, ReadItemBaseGroupDto, ReadStoreItemComboDto, } from '../generated-dto';
export function plainToClassMixedTypes(items) {
    const transformOptions = { groups: [StoreItemsExposeGroup.READ], exposeUnsetFields: false };
    return items.map((item) => {
        switch (item.type) {
            case StoreItemTypeEnum.STORE_ITEM:
                return plainToInstanceWithLVS(ReadStoreItemDto, item, transformOptions);
            case StoreItemTypeEnum.STORE_ITEM_GROUP:
                return plainToInstanceWithLVS(ReadStoreItemGroupDto, item, transformOptions);
            case StoreItemTypeEnum.STORE_ITEM_BUNDLE:
                return plainToInstanceWithLVS(ReadStoreItemBundleDto, item, transformOptions);
            case StoreItemTypeEnum.ITEM_BASE:
                return plainToInstanceWithLVS(ReadItemBaseDto, item, transformOptions);
            case StoreItemTypeEnum.CATEGORY:
                return plainToInstanceWithLVS(ReadCategoryDto, item, transformOptions);
            case StoreItemTypeEnum.ITEM_OPTIONS:
                return plainToInstanceWithLVS(ReadItemOptionsDto, item, transformOptions);
            case StoreItemTypeEnum.ITEM_BASE_GROUP:
                return plainToInstanceWithLVS(ReadItemBaseGroupDto, item, transformOptions);
            case StoreItemTypeEnum.COMBO:
                return plainToInstanceWithLVS(ReadStoreItemComboDto, item, transformOptions);
        }
    });
}
//# sourceMappingURL=plainToClassMixedTypes.js.map